/* eslint-disable import/prefer-default-export */
import { createContext } from 'react';

export const LocaleContext = createContext(null);
export const QueryContext = createContext(null);
export const AnswersContext = createContext(null);
export const UserContext = createContext(null);
export const PreviousPathContext = createContext(null);
